import styled from 'styled-components'

import { Container } from '@tribegroup'

export const ThreeLineTextContainer = styled(Container)`
  overflow-y: auto;
  max-height: 3.75rem;
  ${({ preWrap }) => (preWrap ? 'white-space: pre-wrap;' : '')}
  word-wrap: break-word;
`
